export default __webpack_public_path__ + "static/media/coloured-picind-card.3c4682de.jpg";